import { render } from "./TournamentList.vue?vue&type=template&id=6407d1a9&scoped=true"
import script from "./TournamentList.vue?vue&type=script&lang=js"
export * from "./TournamentList.vue?vue&type=script&lang=js"

import "./TournamentList.vue?vue&type=style&index=0&id=6407d1a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6407d1a9"]])

export default __exports__